import { get, PersonalDetailsUrls } from '@mobi/account/Utils'
import { StreetTypeSuggestions, SuburbStateSuggestions } from '@mobi/api-types'

export function searchStreetTypes(search: string) {
  return get<StreetTypeSuggestions>(PersonalDetailsUrls.streeTypeList(search))
}

export function searchSuburbStatePostcodes(search: string) {
  return get<SuburbStateSuggestions>(PersonalDetailsUrls.suburbList(search))
}
